export const withoutKey = (key) => (state) => {
    if (key in state) {
        const newState = { ...state };
        delete newState[key];
        return newState;
    }
    return state;
};
